
import config from "./config";


if (!localStorage.getItem("randomNumber")) {
  //generate 5 digit random no
  const min = 10000;
  const max = 99999;
  const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  console.log("----- random number ----->", randomNumber);
  localStorage.setItem("randomNumber", randomNumber);
}
//----> session id generate logic
var sessionTime = localStorage.getItem("sessionTime")
  ? localStorage.getItem("sessionTime")
  : "";
var sessionId = localStorage.getItem("sessionId")
  ? localStorage.getItem("sessionId")
  : "";
if (sessionTime && sessionId && Date.now() - sessionTime > 300000) {
  // 5 min
  console.log(
    "----- session id updated : --->" +
      Date.now() +
      "" +
      localStorage.getItem("randomNumber")
  );
  const a = Date.now() + "" + localStorage.getItem("randomNumber");
  localStorage.setItem("sessionId", a);
  localStorage.setItem("user_type", "repeatedUser"); // repeated user
}
sessionTime = Date.now();
if (sessionId === "") {
  //set session id for first time only
  sessionId = sessionTime + "" + localStorage.getItem("randomNumber");
  localStorage.setItem("sessionId", sessionId);
}
localStorage.setItem("sessionTime", sessionTime);

// ----> generate device id
var deviceId = localStorage.getItem("device_id")
  ? localStorage.getItem("device_id")
  : "";
if (deviceId === "") {
  // milli seconds till generate
  deviceId = Date.now() + "" + localStorage.getItem("randomNumber");
  console.log("----- device id set : --->" + deviceId);
  localStorage.setItem("device_id", deviceId);
}

// ----> msisdn calc

export function SendGuiDataEvents(data) {
  if (new Date().getTime() - sessionStorage.getItem("lastPublish") > 300000) {
    //5mins
    sessionStorage.setItem("sessionStartTime", new Date().getTime());
  }
  sessionStorage.setItem("lastPublish", new Date().getTime());

  const guiDataEvent = {
    w_country:"GC",
    w_click_time: new Date().toISOString(),
    ref: document.referrer || "NA",
    operator_id:  "mtngc",
    ua: navigator.userAgent,
    w_host: window.location.hostname, 
    w_req_url: window.location.href,
    req_time: new Date().toISOString(), 
    ts: new Date().toISOString(),
    w_device: "NA",
    opt: "MTN",
    service: "magicvoice",
    uid: localStorage.getItem("uid")
      ? localStorage.getItem("uid")
      :'NA' ,
    msisdn: localStorage.getItem("msisdn")
      ? localStorage.getItem("msisdn")
      :'NA' ,
    mtype:localStorage.getItem("mtype") || "",
    blocked : localStorage.getItem("blocked") || 0,
    breason : localStorage.getItem("breason") || "",
    sid:localStorage.getItem("sessionId") || "",
    campid : localStorage.getItem("campId") || sessionStorage.getItem("campId") || "NA",
    rcid: localStorage.getItem("rcid") || sessionStorage.getItem("rcid") || "NA",
  };

  let objData = { ...data,...guiDataEvent };
  console.log("Elastic Event Data::",objData);
  var jsonData_base64 = window.btoa(JSON.stringify(objData)); //base_64

  let url =  config.get("elasticPublish");
  fetch(url, { method: "POST",headers: { "guiTopic": "waplogs" }, body: jsonData_base64 })
    .then((resp) => {
      console.log("resp ==>>>", resp);
    })
    .catch((error) => {
      console.log("error", error);
    });
}
